import { useEffect, useRef, useState } from 'react';

export const Reveal = ({ children, delay = 0, className = '', as: Tag = 'div' }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setTimeout(() => setVisible(true), delay);
                    obs.disconnect();
                }
            },
            { threshold: 0.12 }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, [delay]);

    return (
        <Tag ref={ref} className={`reveal ${visible ? 'is-visible' : ''} ${className}`}>
            {children}
        </Tag>
    );
};
